import { FlattenSimpleInterpolation } from 'styled-components'

export enum ThemeEnum  {
  light = "light",
  dark = "dark"
} 

export interface ITheme {
  colors: {
    navBackground: string,
    navMainBackground: string,
    primaryBackground: string,
    primaryBackgroundUrl: string,
    secondaryBackground: string,
    secondaryBackgroundNT: string,
    thirdlyBackground: string,
    backgroundColor1: string,
    footerBackground: string,
    footerSocialLinkHover: string,
    cardBorderColor: string,
    scrollTopButtonBackground: string,
    scrollTopButtonBackgroundHover: string,
    scrollTopButtonBackgroundBorder: string,


    primary: string,
    primaryDark: string,
    primaryLight: string,
    secondary: string,
    secondaryDark: string,
    secondaryLight: string,
    success: string,
    successDark: string,
    successLight: string,
    danger: string,
    dangerDark: string,
    dangerLight: string,

    error: string
    overlay: string

    white: string
    black: string
    red: string
    darkRed: string
    accent: string

    bg: string
    primaryFont: string
    secondaryFont: string
    navFont: string
    navLogoFont: string
    navFontHover: string
    navFontBackHover: string
    title: string
    text: string
  }

  font: {
    family: string
    primaryFont: string
    secondaryFont: string
  }

  media: {
    ultraLarge: string
    extraLarge: string
    large: string
    medium: string
    small: string
    extraSmall: string
  }

  sizes: {
    header: { height: number }
    container: { width: number }
    footer: { height: number }
    modal: { width: number }
  },

  durations: {
    ms300: number,
  }

  order: {
    header: number,
    modal: number,
  }

  business: {
    colors: {
      primary: string
      primaryBackground: string
      titleColor: string
      textColor: string
      navBackground: string
      footerBackground: string

      cardBackground1: string
      cardBackground2: string
      cardBackground3: string

      bannerInfoBackground: string
      bannerPhoneHintBg: string

      sliderBorderColor: string
      sliderBackground: string

      tariffBase: string
      tariffPro: string
      tariffEnterprise: string

      storyBackground: string

      functionalTabItemActiveColor: string
      functionalTabItemActiveBackground: string
      functionalTabItemColor: string
      functionalTabItemBackground: string

      functionalRateCellColor: string
      functionalRateCellBackground: string

      feedbackFormInputBackground: string
      feedbackFormInputBorder: string

      aboutImageBackground: string
    }
  }
}

export type StyledVariants<E extends string | number> = {
  [key in E]?: FlattenSimpleInterpolation
}
